import vue from 'vue'
import akDate from '@/core/component/akDate'
import { deleteMethods } from '@/components/tools/index.js'
const that = vue.prototype
export default {
  className: '_User',
  // 其它js用searchKey对应的pointer表必须render
  // render (record) {
  //   return `${record.name} (${record.phone})`
  // },
  fields: [
    {
      name: 'avatar',
      tooltip: '尺寸1 : 1，建议200px * 200px'
    },
    {
      name: 'name',
      validators: [
        (val) => val ? null : '真实姓名不可为空'
      ]
    },
    {
      name: 'gender'
    },
    {
      name: 'phone',
      validators: [
        (val) => val ? null : '手机号不可为空',
        (val) => {
          if (!(/^1[3456789]\d{9}$/.test(val))) {
            return '请输入正确的手机号码'
          }
        }
      ],
      tooltip: '请输入有效的手机号码，新建后则为不可修改项，请谨慎填写'
    },
    {
      name: 'birthdayType',
      width: 150
    },
    {
      name: 'birthday',
      view: {
        component: akDate
      }
    },
    {
      name: 'accountCategory',
      width: 150,
      validators: [
        (val) => val ? null : '账号类别不可为空'
      ],
      tooltip: '新建后则为不可修改项，请谨慎填写'
    },
    {
      name: 'membershipLevel',
      note: '会员级别',
      width: 150,
      tooltip: '新建后则为不可修改项，请谨慎填写'
    },
    {
      name: 'growthValue',
      note: '会员成长值',
      width: 150,
      tooltip: '仅支持代理账号，输入必须为大于零的数字，新建后则为不可修改项，请谨慎填写'
    },
    {
      name: 'belongingAccount',
      note: '归属账号',
      listWhere: (where) => {
        where.accountCategory = 'countyAccount'
      },
      tooltip: '新建后则为不可修改项，请谨慎填写'
    },
    {
      name: 'brandName',
      note: '品牌名'
    },
    'businessType',
    'storeName',
    'storeAddress'
  ],
  search: [
    'phone',
    'name',
    'accountCategory',
    'membershipLevel'
  ],
  action: {
    edit: {
      type: 'row',
      fieldsPlus: {
        phone: {
          disabled: true
        },
        accountCategory: {
          disabled: true
        },
        membershipLevel: {
          disabled: true
        },
        growthValue: {
          disabled: true
        },
        belongingAccount: {
          disabled: true
        }
      }
    },
    delete: {
      type: 'row',
      text: '删除',
      callback: deleteMethods
    },
    allExport: {
      type: 'list',
      align: 'left',
      text: '导入用户信息',
      buttonType: 'primary',
      callback: async ({ vm }) => {
        await vm.confirm('提示', '您将花费少量时间导入信息，请耐心等待...')
        let excel = await vm.$excel.pick()
        let data = excel.toJson().Sheet1
        let typeArr = ['终端账号', '代理账号', '厂家账号']
        vm.$loading.show()
        let phoneArr = data.map(s => { return s['电话'] })
        if (new Set(phoneArr).size !== phoneArr.length) {
          vm.$loading.hide()
          throw that.$notification['error']({
            message: '有相同手机号存在',
            description: '请检查后重试'
          })
        }
        for (let i in data) {
          let s = data[i]
          // 判断手机号是否正确
          if ((!s['电话'] || !(/^1[3456789]\d{9}$/.test(s['电话'])))) {
            vm.$loading.hide()
            throw that.$notification['error']({
              message: '手机号码不正确',
              description: '请检查后重试'
            })
          }
          // 判断其他信息是否存在
          if (!s['姓名'] || !s['经营类型'] || !s['账号类别'] || !['门店地址'] || !['详细地址']) {
            vm.$loading.hide()
            throw that.$notification['error']({
              message: '信息不全',
              description: '请检查后重试'
            })
          }
          // 判断账号类别名字是否有误
          let typeSome = typeArr.some(m => { return m === s['账号类别'] })
          if (!typeSome) {
            vm.$loading.hide()
            throw that.$notification['error']({
              message: '账号类别填写有误',
              description: '请检查后重试'
            })
          }
          // 终端账号无归属信息
          if ((s['账号类别'] === '终端账号' && !s['归属账号']) ||
            (s['归属账号'] && !(/^1[3456789]\d{9}$/.test(s['归属账号'])))) { // 终端账号无归属
            vm.$loading.hide()
            throw that.$notification['error']({
              message: '终端账号无归属信息',
              description: '请检查后重试'
            })
          }
          // 厂家账号无品牌名称
          if (s['账号类别'] === '厂家账号' && !s['品牌名']) { // 厂家账号无品牌名
            vm.$loading.hide()
            throw that.$notification['error']({
              message: '厂家账号无品牌名信息',
              description: '请检查后重试'
            })
          }
          // 判断有无重复账号
          let res = await vm.$modelAjax.getList(`_User`, { params: { limit: 1, where: { phone: s['电话'] } } })
          if (res.length) {
            vm.$loading.hide()
            throw that.$notification['error']({
              message: '数据库已有账号信息',
              description: '请检查后重试'
            })
          }
          // 判断数据库是否有终端账号归属
          if (s['账号类别'] === '终端账号') {
            // 看数据库有无此账号信息
            let res = await vm.$modelAjax.getList(`_User`, { params: { limit: 1, where: { phone: s['归属账号'] } } })
            if (!res.length) {
              vm.$loading.hide()
              throw that.$notification['error']({
                message: '数据库无此终端归属账号信息',
                description: '请检查后重试'
              })
            }
            if (res[0].accountCategory !== 'countyAccount') {
              vm.$loading.hide()
              throw that.$notification['error']({
                message: '数据库终端归属账号信息不匹配',
                description: '请检查后重试'
              })
            }
            // 判断归属账号信息是否已为其他终端归属
            let belongingAccount = await vm.$modelAjax.getList(`_User`, { params: { limit: 1, where: { belongingAccount: res[0].objectId } } })
            if (belongingAccount.length) {
              vm.$loading.hide()
              throw that.$notification['error']({
                message: '终端归属账号已被占用',
                description: '请检查后重试'
              })
            }
          }
        }
        await Promise.all(data.map(async s => {
          // 对经营类别的处理
          let arr = s['经营类型'].split('，')
          let businessType = arr.map(s => {
            if (s === '整车') { s = 'car' }
            if (s === '配件') { s = 'accessories' }
            if (s === '维修') { s = 'maintenance' }
            return s
          })
          // 对归属账号的处理
          let belongingAccount = []
          if (s['归属账号']) {
            belongingAccount = await vm.$modelAjax.getList('_User', {
              params: {
                limit: 1,
                where: {
                  phone: s['归属账号']
                }
              }
            })
          }
          let alias = ''
          if (s['账号类别'] === '代理账号') { alias = 'countyAccount' }
          if (s['账号类别'] === '终端账号') { alias = 'terminalAccount' }
          if (s['账号类别'] === '厂家账号') { alias = 'factoryAccount' }
          return vm.$tkParse.post(`/classes/_User`, {
            name: s['姓名'],
            phone: s['电话'],
            storeName: s['门店名称'] || '',
            storeAddress: s['详细地址'] || '',
            businessType: businessType,
            accountCategory: alias,
            brandName: s['品牌名'] || '',
            belongingAccount: belongingAccount && belongingAccount.length &&
            belongingAccount[0].objectId ? belongingAccount[0].objectId : null,
            isDeleted: false
          })
        })).catch(e => {
          throw that.$notification['error']({
            message: '用户信息导入失败',
            description: '请检查后重试'
          })
        })
        vm.$notification['success']({
          message: '导入完成',
          description: '已导入所有用户数据'
        })
        vm.refresh()
        vm.$loading.hide()
      }
    }
  },
  hooks: {
    /**
     * 給查询添加条件
     * @date: 2020/3/9
     */
    beforeFetch ({ where, modelName }) {
      where.adminRole = {
        $exists: false
      }
    },
    // 保存数据前判断
    async beforeSave (options) {
      let data = options.data
      // 判断是否有空值
      if (data.accountCategory === 'countyAccount' && !data.membershipLevel) {
        throw that.$notification['error']({
          message: '账号必须选择对应级别',
          description: '保存失败'
        })
      }
      if (data.accountCategory === 'terminalAccount' && !data.belongingAccount) {
        throw that.$notification['error']({
          message: '终端账号必须选择对应归属',
          description: '保存失败'
        })
      }
      // 账号类别与级别判断
      if (data.accountCategory !== 'countyAccount' && data.membershipLevel) {
        throw that.$notification['error']({
          message: '不是代理账号无法选择级别',
          description: '保存失败'
        })
      }
      // 判断有没有创建相同用户
      if (!options.objectId) {
        // 判断终端账号归属是否正确
        if (data.accountCategory === 'terminalAccount') {
          let belongingAccount = await that.$modelAjax.getList('user', { params: { where: { objectId: data.belongingAccount } } })
          if (!belongingAccount.length) {
            throw that.$notification['error']({
              message: '该用户没有选择归属账号',
              description: '保存失败'
            })
          }
        }
        let judgeMerchant = await that.$modelAjax.getList(`user`, { params: { where: { phone: data.phone } } })
        if (judgeMerchant.length) {
          throw that.$notification['error']({
            message: '已有该用户信息',
            description: '保存失败'
          })
        }
      }
      // 维护生日字段
      if (data.birthday) {
        let date = new Date(data.birthday)
        let month = date ? date.getMonth() + 1 : 0
        let day = date ? date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate().toString() : 0
        data.birthDayYear = date ? date.getFullYear() : 0
        data.birthDayMonthDay = Number(month.toString() + day.toString())
      }
    }
  }
}
